import UserManage from './user_manage.vue';

export default UserManage;
